import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock-upgrade';
import { cl } from '@/js/utils/index';


declare global {
  interface Window {
    lockedEl: HTMLElement|null;
  }
}

function getScrollbarWidth(): number {
  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';
  var inner = document.createElement('div');
  inner.style.width = '100%';
  inner.style.opacity = '0';
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth;
  outer.parentNode?.removeChild(outer);
  return widthNoScroll - widthWithScroll;
}

export function setScrollBarVar() {
  const scGap = getScrollbarWidth();
  if (scGap) {
    document.body.style.setProperty('--scrollbar', scGap + 'px');
  }
}

const scrollLock = function (el: HTMLElement, callback?: (scGap: number) => void) {
  const scGap = getScrollbarWidth();
  (window as any).lockedEl = el;
  disableBodyScroll(el);
  cl(document.documentElement).add('scroll-locked');
  if (scGap) {
    document.body.style.setProperty('--scroll-gap', scGap + 'px');
  }

  if (callback) {
    callback(scGap);
  }
};

const scrollUnLock = function (callback?: () => void) {
  if (window.lockedEl) {
    cl(document.documentElement).remove('scroll-locked');
    clearAllBodyScrollLocks()

    document.body.style.removeProperty('--scroll-gap');

    window.lockedEl = null;

    if (callback) {
      callback();
    }
  }
};

export { getScrollbarWidth, scrollLock, scrollUnLock, clearAllBodyScrollLocks };
